import { TOKEN } from "constants/constants";
import { useLocation, Navigate, Outlet } from "react-router-dom";

const RequireUserAuth = () => {
  const auth = sessionStorage.getItem(TOKEN);
  const location = useLocation();

  return auth ? (
    <Outlet />
  ) : (
    <Navigate to="/login" state={{ from: location }} replace />
  );
};

export default RequireUserAuth;
